<template>
  <div class="flex-grow">
    <iframe v-if="pageUrl" :src="pageUrl" width="100%" height="100%" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PartnersHowItWorks',
  computed: {
    ...mapGetters({
      getPartnerById: 'partners/getPartnerById',
    }),
    partnerId() {
      return this.$route.params.id;
    },
    partner() {
      return this.getPartnerById(this.partnerId);
    },
    partnerUuid() {
      return this.partner?.uuid ?? [];
    },
    pageUrl() {
      return `${process.env.VUE_APP_BASE_URL_ROOT.replace(/\/$/, '')}/web/partner/${this.partnerUuid}`;
    },
  },
};
</script>
